export default __webpack_public_path__ + "static/media/15.bca8e515.png";